// extracted by mini-css-extract-plugin
export default {"cost":"CostCard_cost__L9Fsl","cost__title":"CostCard_cost__title__EpjfK","cost__info":"CostCard_cost__info__PGj9N"};